import { locationActions } from "../../actionTypes";

const initialState = {
	status: false,
	loading: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case locationActions.VERIFY_LOCATION_EMAIL: {
			return { ...state, loading: true };
		}

		case locationActions.VERIFY_LOCATION_EMAIL_FULLFILLED: {
			return { ...state, loading: false, status: true };
		}

		case locationActions.VERIFY_LOCATION_EMAIL_REJECTED: {
			return { ...state, loading: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
